export const env = {
  adminApiBaseUrl:
    (import.meta.env.VITE_ADMIN_API_BASE_URL as string | undefined)?.replace(/\/$/, '') ??
    'http://localhost:3001',
  appEnv: (import.meta.env.VITE_APP_ENV as string | undefined) ?? 'development',
} as const;
